export default __webpack_public_path__ + "static/media/emptyState_Search.93180851.svg";